import React from "react";

const PageHeader = ({ title, subtitle, actions }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
        marginBottom: 16,
      }}
    >
      <div style={{ minWidth: 0 }}>
        <h2
          style={{
            margin: 0,
            fontSize: 20,
            fontWeight: 700,
            color: "var(--i-ems-text)",
            lineHeight: 1.3,
          }}
        >
          {title}
        </h2>
        {subtitle && (
          <div style={{ marginTop: 2, fontSize: 13, color: "var(--i-ems-text-secondary)" }}>
            {subtitle}
          </div>
        )}
      </div>
      {actions && <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>{actions}</div>}
    </div>
  );
};

export default PageHeader;
